(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var v = document.getElementById('cineVideo');
  if(!v) return;
  var FADE = 0.5;      // seconds
  var resetting = false;
  function frame(){
    var d = v.duration;
    if(!resetting && d && isFinite(d) && d > 0){
      var t = v.currentTime;
      var fin = Math.min(t / FADE, 1);
      var fout = Math.min((d - t) / FADE, 1);
      var o = Math.max(0, Math.min(fin, fout));
      v.style.opacity = o.toFixed(3);
    }
    requestAnimationFrame(frame);
  }
  v.addEventListener('ended', function(){
    resetting = true;
    v.style.opacity = '0';
    setTimeout(function(){
      try { v.currentTime = 0; } catch(e){}
      var p = v.play();
      if(p && p.catch){ p.catch(function(){}); }
      resetting = false;
    }, 100);
  });
  var p = v.play();
  if(p && p.catch){ p.catch(function(){}); }
  requestAnimationFrame(frame);
})();

  } catch(e) { console.error(e); }
})();
})();
